skrilla.service('productIntegrityReportService', function() {

    function buildTableForEntries(tag, entries, reportType){

        switch (tag){
            case "FFA":
                return buildTableForFootballAusEntries(entries);
            case "AFL":
                if(reportType === "SUSPICIOUS_BET_AMOUNTS"){
                    return buildTableForAFLSuspiciousAusEntries(entries)
                }
                else {
                    return buildTableForAFLEntries(entries);
                }
            case "NRL":
                return buildTableForNRLEntries(entries);
            case "TENNIS_AUS":
                return buildTableForTennisAusEntries(entries)
            case "BASKETBALL_AUS":
                return buildTableForBasketballAusEntries(entries);
            default: return null;
        }
    }

    function buildTableForFootballAusEntries(entries){
        return {
            columns: [
                {title: "Match", field: "match"},
                {title: "Amount staked", field: "amountStaked", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "First Name", field: "firstName"},
                {title: "Last Name", field: "lastName"},
                {title: "Date Of Birth", field: "dateOfBirth", filter:{name: 'dateTimeFormatter', args: ['DD-MM-yyyy']}},
                {title: "Mobile Number", field: "mobileNumber"},
                {title: "User ID", field: "userId"},
            ],
            rows: {orderBy: "eventDate"},
            isSkrillaTable: true,
            data: entries
        }
    }

    function buildTableForAFLSuspiciousAusEntries(entries){
        return {
            columns: [
                {title: "Market", field: "market"},
                {title: "Match", field: "match"},
                {title: "Amount staked", field: "amountStaked", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "First Name", field: "firstName"},
                {title: "Last Name", field: "lastName"},
                {title: "Date Of Birth", field: "dateOfBirth", filter:{name: 'dateTimeFormatter', args: ['DD-MM-yyyy']}},
                {title: "Mobile Number", field: "mobileNumber"},
                {title: "User ID", field: "userId"},
            ],
            rows: {orderBy: "eventDate"},
            isSkrillaTable: true,
            data: entries
        }
    }

    function buildTableForAFLEntries(entries){
        return {
            columns: [
                {title: "Match", field: "match"},
                {title: "Unique Bettors", field: "uniqueBettors"},
                {title: "Number of bets", field: "numberOfBets"},
                {title: "H2H Turnover", field: "headToHeadTurnover", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Margin/Spread Turnover", field: "marginTurnover", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Over/Under Turnover", field: "overOrUnderTurnover", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "First Goal Kick Turnover", field: "firstGoalKickTurnover", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Other Turnover", field: "otherTurnover", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "H2H G/R", field: "headToHeadGrossRevenue", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Margin/Spread G/R", field: "marginGrossRevenue", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Over/Under G/R", field: "overOrUnderGrossRevenue", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "First Goal G/R", field: "firstGoalKickGrossRevenue", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Other G/R", field: "otherGrossRevenue", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            ],
            rows: {orderBy: "eventDate"},
            isSkrillaTable: true,
            data: entries
        }
    }

    function buildTableForNRLEntries(entries){
        return {
            columns: [
                {title: "User Id", field: "userId"},
                {title: "Event", field: "event"},
                {title: "Bet Type", field: "betType"},
                {title: "Stake", field: "stake", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Potential Payout", field: "potentialPayout", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Liability", field: "liability", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Stake Source", field: "stakeSource"},
            ],
            rows: {orderBy: "eventDate"},
            isSkrillaTable: true,
            data: entries
        }
    }

    function buildTableForTennisAusEntries(entries){
        return {
            columns: [
                {title: "Account Number", field: "userId"},
                {title: "First Name", field: "firstName"},
                {title: "Last Name", field: "lastName"},
                {title: "Date Of Birth", field: "dateOfBirth", filter:{name: 'dateTimeFormatter', args: ['DD-MM-yyyy']}},
                {title: "Event", field: "event"},
                {title: "Bet Time", field: "betCreatedAt", filter:{name: 'dateTimeFormatter'}},
                {title: "Bet Type", field: "betType"},
                {title: "Selection", field: "outcomeName"},
                {title: "Market", field: "marketName"},
                {title: "Stake", field: "stake", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Odds", field: "odds"},
                {title: "Line", field: "line"},
                {title: "Result", field: "result"},
                {title: "How Placed", field: "howPlaced"},
                {title: "IP Address", field: "ipAddress"},
            ],
            rows: {orderBy: "eventDate"},
            isSkrillaTable: true,
            data: entries
        }
    }

    function buildTableForBasketballAusEntries(entries){
        return {
            columns: [
                {title: "User ID", field: "userId"},
                {title: "Client Name", field: "clientName"},
                {title: "Date of Birth", field: "dateOfBirth", filter: {name: 'dateTimeFormatter', args: ['DD-MM-yyyy']}},
                {title: "Address", field: "address"},
                {title: "Email", field: "email"},
                {title: "Bet Date", field: "betDate", filter: {name: 'dateTimeFormatter', args: ['DD-MM-yyyy']}},
                {title: "Bet Time", field: "betTime", filter: {name: 'dateTimeFormatter', args: ['HH:mm:ss']}},
                {title: "Competition", field: "competition"},
                {title: "Home Team", field: "homeTeam"},
                {title: "Away Team", field: "awayTeam"},
                {title: "Market", field: "market"},
                {title: "Single or Multi", field: "singleOrMulti"},
                {title: "Odds", field: "odds"},
                {title: "Turnover", field: "turnover", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Returns", field: "returns", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
                {title: "Retained Margin", field: "retainedMargin", filter: {name: "dollarOrSkrilla", args: ['AUD', false]}},
            ],
            rows: {orderBy: "eventDate"},
            isSkrillaTable: true,
            data: entries
        }
    }

/*
    val createdAt: OffsetDateTime
 */
    return {
        buildTableForEntries: buildTableForEntries
    };
});
